import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Eye, X } from 'lucide-react';
import { useAuth } from '@/contexts/AuthContext';

/**
 * Fixed top banner shown while an admin is viewing the app as another user.
 * "Exit" restores the admin session and returns to the backend panel.
 */
export default function ImpersonationBanner() {
  const { impersonating, user, stopImpersonating } = useAuth();
  const navigate = useNavigate();
  const { t } = useTranslation();

  if (!impersonating) return null;

  const onExit = async () => {
    await stopImpersonating();
    navigate('/admin', { replace: true });
  };

  return (
    <div className="fixed top-0 inset-x-0 z-[100] bg-amber-500 text-amber-950 text-sm font-medium shadow-md">
      <div className="max-w-7xl mx-auto px-4 py-2 flex items-center justify-center gap-3">
        <Eye className="w-4 h-4 flex-shrink-0" />
        <span className="truncate">
          {t('admin.impersonation.viewingAs', { name: user?.name || user?.email })}
        </span>
        <button
          onClick={onExit}
          className="ml-2 inline-flex items-center gap-1 bg-amber-950 text-amber-50 rounded px-2 py-0.5 hover:bg-amber-900 transition"
        >
          <X className="w-3.5 h-3.5" /> {t('admin.impersonation.exit')}
        </button>
      </div>
    </div>
  );
}
